import request from "@/utils/request";

let SupplierApi = {
    /*供货商列表*/
    SupplierList(data, errorback) {
        return request._post("/merch/supplier.supplier/index", data, errorback);
    },
    /*添加供货商*/
    addSupplier(data, errorback) {
        return request._post("/merch/supplier.supplier/add", data, errorback);
    },
    /*添加供货商*/
    toaddSupplier(data, errorback) {
        return request._get("/merch/supplier.supplier/add", data, errorback);
    },
    /*供货商详情*/
    SupplierDetail(data, errorback) {
        return request._get("/merch/supplier.supplier/detail", data, errorback);
    },
    /*修改供货商*/
    editSupplier(data, errorback) {
        return request._post("/merch/supplier.supplier/edit", data, errorback);
    },
    /*删除供货商*/
    deleteSupplier(data, errorback) {
        return request._post("/merch/supplier.supplier/delete", data, errorback);
    }
};

export default SupplierApi;



// WEBPACK FOOTER //
// ./src/api/supplier.js